// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ellips {
  display: block;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Arial, Helvetica, sans-serif;
}

.isactive {
  background-color: #00bbbb;
  color: white;
}

.submain {
  background-color: #d8eaed;
}

.IsDefault {
  background-color: #12127c;
  color: white;
}
.IsDefault .Actionitems {
  background-color: white !important;
  color: #12127c !important;
}

.addsub:hover {
  background-color: rgb(249, 246, 246);
}

.Actionitems {
  font-size: 13px;
  height: 24px;
  line-height: 1px;
}

::ng-deep.menu_accordian {
  margin-block: 5px !important;
  box-shadow: rgba(99, 99, 99, 0.2) 1px 1px 5px 2px !important;
}

.editmenuBtn {
  background-color: #17a0b4 !important;
  font-size: 12px !important;
  color: white;
  cursor: pointer;
}

.togglelabel {
  text-align: center;
  line-height: 6;
}

:ng-deep.actionsItemDrop.mat-menu-panel {
  height: 275px !important;
  overflow-x: hidden !important;
  min-width: 150px !important;
  max-width: 292px !important;
  min-height: auto !important;
}

::ng-deep .RMModalForm .modal-dialog {
  max-width: 43% !important;
  height: 30vh;
  top: 16%;
  width: 95vw;
  left: 30.5%;
  margin: 0;
  position: fixed;
}
::ng-deep .RMModalForm .modal-content {
  height: 30vh;
}`, "",{"version":3,"sources":["webpack://./src/app/CIIS/manage-menus/manage-menus.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEE;EACE,cAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,yCAAA;AADJ;;AAQE;EAEE,yBAAA;EACA,YAAA;AANJ;;AAQA;EAEE,yBAAA;AANF;;AAQE;EAEE,yBAAA;EACA,YAAA;AANJ;AAOI;EACE,kCAAA;EACA,yBAAA;AALN;;AASE;EAEE,oCAAA;AAPJ;;AAUE;EAEE,eAAA;EACA,YAAA;EACA,gBAAA;AARJ;;AA2CA;EACE,4BAAA;EACA,4DAAA;AAxCF;;AA2CA;EACE,oCCrFU;EDsFV,0BCrFS;EDsFT,YAAA;EACA,eAAA;AAxCF;;AA0CA;EAEE,kBAAA;EACA,cAAA;AAxCF;;AA2CA;EACE,wBAAA;EACA,6BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;AAxCF;;AA6CE;EACE,yBAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AA1CJ;AA6CE;EACE,YAAA;AA3CJ","sourcesContent":["@import \"../../../variables.scss\";\r\n\r\n  .ellips {\r\n    display: block;\r\n    white-space: nowrap;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    font-size: 14px;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n  }\r\n  // .noactions\r\n  // {\r\n  //   padding-left: 20%;\r\n  // }\r\n\r\n  .isactive\r\n  {\r\n    background-color: #00bbbb;\r\n    color:white;\r\n  }\r\n.submain\r\n{\r\n  background-color: #d8eaed;\r\n}\r\n  .IsDefault\r\n  {\r\n    background-color: #12127c;\r\n    color: white;\r\n    .Actionitems{\r\n      background-color: white !important;\r\n      color: #12127c !important;\r\n    }\r\n  }\r\n\r\n  .addsub:hover\r\n  {\r\n    background-color: rgb(249, 246, 246);\r\n  }\r\n\r\n  .Actionitems\r\n  {\r\n    font-size: 13px;\r\n    height: 24px;\r\n    line-height: 1px;\r\n}\r\n\r\n// .menuManageTab{\r\n//   ::ng-deep .mat-ink-bar {\r\n//     background-color: rgba(0, 0, 0, 0) !important;\r\n//   }\r\n\r\n//   ::ng-deep .mat-tab-label {\r\n//     // background-color: rgb(238, 180, 23) !important;\r\n//     height: 30px  !important;\r\n//     opacity:unset !important;\r\n//     padding-inline: 1% !important;\r\n//   }\r\n\r\n//   ::ng-deep .mat-tab-label.mat-tab-label-active {\r\n//     min-width: 85px !important;\r\n//     padding: 5px 10px;\r\n//     background-color: #12127c;\r\n//     color: white;\r\n//     font-weight: 700;\r\n//     border-top-left-radius: 5px;\r\n//     border-top-right-radius: 5px;\r\n//     margin-left: 1% !important;\r\n//     height: 31px !important;\r\n//   }\r\n//   ::ng-deep .mat-tab-label {\r\n//     min-width: 25px !important;\r\n//     padding: 5px;\r\n//     background-color: transparent;\r\n//     color: black;\r\n//     font-weight: 700;\r\n//   }\r\n// }\r\n\r\n::ng-deep.menu_accordian{\r\n  margin-block: 5px !important;\r\n  box-shadow: rgb(99 99 99 / 20%) 1px 1px 5px 2px !important;\r\n}\r\n\r\n.editmenuBtn{\r\n  background-color:$btn-color;\r\n  font-size: $fontsize;\r\n  color:white ;\r\n  cursor: pointer;\r\n}\r\n.togglelabel\r\n{\r\n  text-align: center;\r\n  line-height: 6;\r\n}\r\n\r\n:ng-deep.actionsItemDrop.mat-menu-panel{\r\n  height: 275px !important;\r\n  overflow-x: hidden !important;\r\n  min-width: 150px !important;\r\n  max-width: 292px !important;\r\n  min-height: auto !important;\r\n}\r\n\r\n// Styles for RMModalForm modal to preserve original appearance\r\n::ng-deep .RMModalForm {\r\n  .modal-dialog {\r\n    max-width: 43% !important;\r\n    height: 30vh;\r\n    top: 16%;\r\n    width: 95vw;\r\n    left: 30.5%;\r\n    margin: 0;\r\n    position: fixed;\r\n  }\r\n  \r\n  .modal-content {\r\n    height: 30vh;\r\n  }\r\n}\r\n\r\n   \r\n","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
